import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[dropdownTrigger]'
})
export class DropdownTriggerDirective {
  constructor(public template: TemplateRef<any>) { }
}
